import { render, staticRenderFns } from "./ModalResetPassword.vue?vue&type=template&id=cce635fc&"
import script from "./ModalResetPassword.vue?vue&type=script&lang=ts&"
export * from "./ModalResetPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports